export default {
  "userDepositBonusAdmin.thead.index": "#",
  "userDepositBonusAdmin.thead.documentId": "Document ID",
  "userDepositBonusAdmin.thead.bindSite": "Bind Site",
  "userDepositBonusAdmin.thead.levelValue": "Level",
  "userDepositBonusAdmin.thead.levelAmount": "Level Experience Requirement",
  "userDepositBonusAdmin.thead.bonusValue": "Level Bonus",
  "userDepositBonusAdmin.thead.weeklyBonus": "Weekly Cashback",
  "userDepositBonusAdmin.thead.monthlyBonus": "Monthly Cashback",
  "userDepositBonusAdmin.thead.withdrawTimesLimit": "Withdrawal Times Limit",
  "userDepositBonusAdmin.thead.withdrawAmountLimit": "Withdrawal Amount Limit",
  "userDepositBonusAdmin.thead.weeklyCashbackConf": "Weekly Cashback Config",
  "userDepositBonusAdmin.thead.monthlyCashbackConf": "Monthly Cashback Config",
  "userDepositBonusAdmin.thead.promotionCashbackConf":
    "Promotion Cashback Config",
  "userDepositBonusAdmin.thead.cashbackAmountType": "Cashback Amount Type",
  "userDepositBonusAdmin.thead.cashbackValue": "Cashback Value",
  "userDepositBonusAdmin.thead.cashbackWithdrawLimit":
    "Cashback Withdrawal Limit",
  "userDepositBonusAdmin.thead.cashbackExpire": "Cashback Expire Hours",
  "userDepositBonusAdmin.thead.startTime": "Reward Claimable Hours",
  "userDepositBonusAdmin.add": "Add",
  "userDepositBonusAdmin.edit": "Edit",
  "userDepositBonusAdmin.details": "Details",
  "userDepositBonusAdmin.delete": "Delete",

  "userDepositBonusAdmin.thead.status": "Status",
  "userDepositBonusAdmin.thead.createdAt": "Created At",
  "userDepositBonusAdmin.thead.updatedAt": "Updated At",
  "userDepositBonusAdmin.thead.action": "Action",

  // Deposit Bonus specific fields
  "userDepositBonusAdmin.thead.id": "ID",
  "userDepositBonusAdmin.thead.bonusId": "Bonus ID",
  "userDepositBonusAdmin.thead.bonusTitle": "Bonus Title",
  "userDepositBonusAdmin.thead.sort": "Sort",
  "userDepositBonusAdmin.thead.bonusDescItems": "Bonus Description Items",
  "userDepositBonusAdmin.thead.claimLimit": "Claim Limit",
  "userDepositBonusAdmin.thead.claimLimitReset": "Claim Limit Reset",
  "userDepositBonusAdmin.thead.maximumDeposit": "Maximum Deposit",
  "userDepositBonusAdmin.thead.minimumDeposit": "Minimum Deposit",
  "userDepositBonusAdmin.thead.expire": "Expire",
  "userDepositBonusAdmin.thead.active": "Active",
  "userDepositBonusAdmin.thead.bonusDescTitle": "Bonus Description Title",
  "userDepositBonusAdmin.thead.currency": "Currency",
  "userDepositBonusAdmin.thead.bonusAmounts": "Bonus Amounts",
  "userDepositBonusAdmin.thead.returnDays": "Return Days",
  "userDepositBonusAdmin.thead.depositType": "Deposit Type",
  "userDepositBonusAdmin.thead.multTimesDepositAmounts":
    "Multiple Times Deposit Amounts",
  "userDepositBonusAdmin.thead.startAt": "Start At",
  "userDepositBonusAdmin.thead.bonusBg": "Bonus Background",
  "userDepositBonusAdmin.thead.singleQueue": "Single Queue",
  "userDepositBonusAdmin.thead.amountRemarkTitle": "Amount Remark Title",
  "userDepositBonusAdmin.thead.setDefaultData": "Set Default Data",
  "userDepositBonusAdmin.thead.channels": "Channels",
  "userDepositBonusAdmin.thead.createdBy": "Created By",
  "userDepositBonusAdmin.thead.updatedBy": "Updated By",

  // Bonus Amounts Component fields
  "userDepositBonusAdmin.thead.displayAmount": "Display Amount",
  "userDepositBonusAdmin.thead.amount": "Amount",
  "userDepositBonusAdmin.thead.cumulativeAmount": "CumulativeAmount",
  "userDepositBonusAdmin.thead.bonus": "BonusRatio",
  "userDepositBonusAdmin.thead.bonus2": "BonusAmount",
  "userDepositBonusAdmin.thead.rollover": "Rollover",
  "userDepositBonusAdmin.thead.setDefaultCheckedAmount":
    "Set Default Checked Amount",
  "userDepositBonusAdmin.thead.freeSpinId": "Free Spin ID",
  "userDepositBonusAdmin.thead.freeSpinRounds": "Free Spin Rounds",
  "userDepositBonusAdmin.thead.isTimeLimit": "IsTimeLimit",
  "userDepositBonusAdmin.thead.specifiedTime": "SpecifiedTime",
  "userDepositBonusAdmin.thead.selectDayOfWeek": "SelectDayOfWeek",
  "userDepositBonusAdmin.thead.selectDay": "SelectDay",
  "userDepositBonusAdmin.thead.bonusWay": "BonusWay",
  "userDepositBonusAdmin.thead.getBonusType": "GetBonusType",
  "userDepositBonusAdmin.thead.numberOfRecharges": "NumberOfRecharges",

  // Deposit Bonus Config fields
  "userDepositBonusAdmin.thead.completeTimes": "Complete Times",
  "userDepositBonusAdmin.thead.titleText": "Title Text",

  // Bonus Description Items fields
  "userDepositBonusAdmin.thead.descText": "Description Text",
  "userDepositBonusAdmin.thead.rightValueText": "Right Value Text",

  // Modal and Delete Confirm texts
  "userDepositBonusAdmin.modal.title": "Title",
  "userDepositBonusAdmin.delete.confirm.title": "Delete Configuration",
  "userDepositBonusAdmin.delete.confirm.content":
    "Are you sure you want to delete this configuration?",
  "userDepositBonusAdmin.delete.confirm.okText": "Confirm",
  "userDepositBonusAdmin.delete.confirm.cancelText": "Cancel",

  //firstDepositLossRebate
  "userDepositBonusAdmin.thead.rewardConfig": "Reward Config",
  "userDepositBonusAdmin.thead.lossRatio": "Loss Ratio(%)",
  "userDepositBonusAdmin.thead.rewardRatio": "Reward Ratio(%)",
  "userDepositBonusAdmin.thead.isDoubleReward": "Is DoubleReward",
  "userDepositBonusAdmin.thead.doubleType": "Duble Type",
  "userDepositBonusAdmin.thead.doubleValue": "Double Value",
  "userDepositBonusAdmin.thead.depositAmounts": "Deposit Amounts",
  "userDepositBonusAdmin.thead.doubleRollover": "Double Rollover",
  
};
